import { Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-modal-ping-linkedin',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './modal-ping-linkedin.component.html',
  styleUrl: './modal-ping-linkedin.component.scss'
})
export class ModalPingLinkedinComponent implements OnInit {

  @ViewChild('linkedinFollow', { static: true }) linkedinFollow?: ElementRef<HTMLDivElement>;


  constructor(public dialogRef: MatDialogRef<ModalPingLinkedinComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,     private renderer: Renderer2
  ) {
  }


  ngOnInit(): void {
    this.initLinkedInFollow();
  }
  onClose() {
    this.dialogRef.close();
  }


  private initLinkedInFollow(): void {
    const container = this.linkedinFollow?.nativeElement;
    if (!container) {
      console.error('LinkedIn follow container not found');
      return;
    }

    const win = window as any;

    const renderWidget = () => {
      container.innerHTML = '';
      const widgetScript = this.renderer.createElement('script');
      widgetScript.type = 'IN/FollowCompany';
      widgetScript.setAttribute('data-id', '103908570');
      widgetScript.setAttribute('data-counter', 'bottom');
      this.renderer.appendChild(container, widgetScript);
      if (win.IN && typeof win.IN.parse === 'function') {
        win.IN.parse(container);
      }
    };

    // If platform script is already loaded, render immediately
    if (win.IN && typeof win.IN.parse === 'function') {
      renderWidget();
      return;
    }

    // Only append the platform script once
    const existing = document.getElementById('linkedin-platform-script');
    if (existing) {
      existing.addEventListener('load', renderWidget, { once: true });
      return;
    }

    const script = this.renderer.createElement('script');
    script.id = 'linkedin-platform-script';
    script.src = 'https://platform.linkedin.com/in.js';
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.text = 'lang: en_US';
    script.onload = () => renderWidget();
    this.renderer.appendChild(document.body, script);
  }

}
